import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Gift, Loader2 } from "lucide-react";
import { adminAuthHeader } from "@/hooks/useAdminAuth";
import { extractApiError } from "@/utils/apiError";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Admin button to manually grant a user FREE access to all lessons + full
 * course. Asks for explicit confirmation before firing.
 * Calls POST /api/admin/users/{userId}/grant-full-access.
 */
export default function GrantFullAccessButton({ userId, userName, alreadyGranted, onGranted }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading || alreadyGranted) return;
    const ok = window.confirm(
      `Sblocco GRATUITO totale per ${userName || "questo utente"}?\n\n` +
      "Verranno attivate TUTTE le 9 lezioni + il corso completo, senza alcun pagamento.\n\n" +
      "Procedere?"
    );
    if (!ok) return;
    setLoading(true);
    try {
      await axios.post(
        `${API}/admin/users/${userId}/grant-full-access`,
        {},
        { headers: adminAuthHeader() },
      );
      toast.success("Accesso completo sbloccato gratuitamente");
      onGranted?.(userId);
    } catch (err) {
      toast.error(extractApiError(err, "Errore nello sblocco accesso"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={loading || alreadyGranted}
      data-testid={`grant-full-access-btn-${userId}`}
      className="inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-md border transition disabled:opacity-50 disabled:cursor-not-allowed"
      style={{
        background: alreadyGranted ? "#ecfdf5" : "#fff7ed",
        borderColor: alreadyGranted ? "#86efac" : "#fdba74",
        color: alreadyGranted ? "#065f46" : "#9a3412",
      }}
      title={alreadyGranted
        ? "Questo utente ha già accesso completo"
        : "Sblocca tutte le lezioni + corso completo gratis"}
    >
      {loading
        ? <><Loader2 size={12} className="animate-spin" /> Sblocco…</>
        : <><Gift size={12} /> {alreadyGranted ? "Accesso completo attivo" : "🎁 Sblocca tutto gratis"}</>}
    </button>
  );
}
